//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'landingPageFooter',
  data () {
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/components/LandingPageFooter.vue